/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect, useState } from 'react'

import type { FunctionComponent } from 'react'

const AutofillBuster: FunctionComponent = ({ children }) => {
  const [display, setDisplay] = useState<'static' | 'none'>('static')

  useEffect(() => {
    let isMounted = true // note mutable flag
    setTimeout(() => {
      if (isMounted) {
        setDisplay('none')
      }
    }, 400)

    return () => {
      isMounted = false
    } // cleanup toggles value, if unmounted
  }, [])

  return (
    <form autoComplete='off'>
      <div style={{ maxHeight: 0, overflow: `hidden` }}>
        <input type='text' style={{ display }} />
        <input type='password' style={{ display }} />
      </div>
      {children}
    </form>
  )
}

export default AutofillBuster
